import { ExclamationTriangleIcon } from '@radix-ui/react-icons'

interface FormErrorProps {
  message?: string | null
}

export const FormError = ({ message }: FormErrorProps) => {
  if (!message) return null

  return (
    <div className="flex items-center gap-x-2 rounded-md bg-destructive/50 p-3 text-sm text-foreground">
      <ExclamationTriangleIcon className="size-5" />
      <p>{message}</p>
    </div>
  )
}
